import { render, staticRenderFns } from "./view-project.vue?vue&type=template&id=e08e5f74&"
import script from "./view-project.vue?vue&type=script&lang=js&"
export * from "./view-project.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports